export var ContributorInputLabels;
(function (ContributorInputLabels) {
  ContributorInputLabels["FUNCTION"] = "Role";
  ContributorInputLabels["FIRST"] = "First Name";
  ContributorInputLabels["MIDDLE"] = "Middle Name";
  ContributorInputLabels["LAST"] = "Last Name";
  ContributorInputLabels["SUFFIX"] = "Suffix";
})(ContributorInputLabels || (ContributorInputLabels = {}));
export var CONTRIBUTOR_TEST_ID = 'contributor';